import * as React from 'react';
import { TypeIconName } from '../Icon/tsx';
import Flex, { Props as FlexProps } from '../Flex/Flex';
import Icon from '../Icon/Icon';

export interface Props extends FlexProps {
  /** Name of the icon that appears next to the text of the link. */
  icon?: TypeIconName;
  /** @Ignore */
  to?: string;
}

/**
 * Link that appears to the very right of the beam.
 */
const AddonBeamLink: React.FunctionComponent<Props> = (props: Props) => {
  const { children, icon, ...rest } = props;

  return (
    <Flex { ...rest }
        className="AddonBeam__link"
        direction="horizontal"
        gap="x1">
      { icon && (
        <Flex>
          <Icon name={ icon } />
        </Flex>
      ) }

      <Flex>
        { children }
      </Flex>
    </Flex>
  );
};

AddonBeamLink.defaultProps = {
  Component: 'a',
};

export default AddonBeamLink;
